export default class ExtraCharges {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.descriptionOther = apiResponse.descriptionOther;
        this.price = apiResponse.price ? Number.parseFloat(apiResponse.price) : null;
    }

    clone() {
        const extraCharges = new ExtraCharges({});
        extraCharges.id = this.id;
        extraCharges.descriptionOther = this.descriptionOther;
        extraCharges.price = this.price;
        return extraCharges;
    }
}